// extracted by mini-css-extract-plugin
export var affiliateNotice = "offer-affiliatenotice-module--affiliateNotice--5U8cz";
export var affiliateNoticeLink = "offer-affiliatenotice-module--affiliateNoticeLink--DWGs9";